module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/childcare-985cd8986ada4d6154c7f8df28137f91.png";